<template>
  <div class="ui-content dashboard res-analisis-page testrsult test-res-12-may-scroll-fix">
    <v-card class="mx-auto normal-card autohg autohgnot">
      <div class="user-data">
        <v-row>
          <v-col cols="12" sm="12">
            <div class="show-drop-down">
              <div class="label-data">Select Center(s)</div>
              <div class="field-data">
                <multi-select
                  allText="All Centers"
                  :items="centers"
                  label="select center"
                  :onChange="onCenterchange"
                  widthcss="fix-width-200"
                ></multi-select>
              </div>
            </div>
            <div class="show-drop-down">
              <div class="label-data">Select Batch(es)</div>
              <div class="field-data">
                <multi-select
                  allText="All Batches"
                  :items="batches"
                  label="select batch"
                  :onChange="onBatchSelect"
                  widthcss="fix-width-200"
                ></multi-select>
              </div>
            </div>
            <v-btn 
              v-if="selectedScheduleIds.length > 1"
              class="right-btn cust-btn"
              color="primary"
              style="margin: 2px"
              @click="downloadResultAsExcelMulti()"
            >Download Combined Result</v-btn>
          </v-col>
        </v-row>
      </div>
      <div class="result-analysis result-card-section test-results-area" ref="testCardBox">
        <div class="result-card-row">
          <div
            class="result-card-col"
            v-for="(test, testIndex) in testResultList"
            :key="test.testIndex"
          >
            <div
              id="rotativeCal"
              class="flipbox-container"
              @mouseleave="flipReset()"
            >
              <div
                class="flipwrap"
                v-bind:class="{
                  'first-to-second': f2sActive && testIndex === currIndex,
                  'first-to-third': f2tActive && testIndex === currIndex,
                  'second-to-third': s2tActive && testIndex === currIndex,
                  'second-to-first': s2fActive && testIndex === currIndex,
                  'third-to-first': t2fActive && testIndex === currIndex,
                  'third-to-second': t2sActive && testIndex === currIndex,
                }"
              >
                <div class="date-box">
                  <div class="date">
                    <v-touch
                      class="result-box"
                      v-on:swipeleft="
                        flipReset(), (f2tActive = true), (currIndex = testIndex)
                      "
                      v-on:swiperight="
                        flipReset(), (f2sActive = true), (currIndex = testIndex)
                      "
                    >
                      <div class="left-move">
                        <svg
                          viewBox="-10 -10 70 95"
                          xml:space="preserve"
                          @click="
                            flipReset(),
                              (f2tActive = true),
                              (currIndex = testIndex)
                          "
                        >
                          <polyline
                            fill="none"
                            stroke="#666"
                            stroke-width="9"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            points="45.63,75.8 0.375,38.087 45.63,0.375 "
                          />
                        </svg>
                      </div>
                      <div class="right-move">
                        <svg
                          viewBox="-10 -10 70 95"
                          xml:space="preserve"
                          @click="
                            flipReset(),
                              (f2sActive = true),
                              (currIndex = testIndex)
                          "
                        >
                          <polyline
                            fill="none"
                            stroke="#666"
                            stroke-width="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            points="0.375,0.375 45.63,38.087 0.375,75.8 "
                          />
                        </svg>
                      </div>
                      <div class="res-body">
                        <div class="subject-heading">
                          {{ test.overAllInfo.testName }}
                          <input
                            type="checkbox"
                            :value="test.scheduleId"
                            v-model="selectedScheduleIds"
                            class="select-checkbox"
                          />
                        </div>
                        <span v-if="instituteId == CONSTANTS_REF.AITS_INSTITUTE_ID[0]" 
                        >{{ `(${test.overAllInfo.instituteName})` }}</span>
                        <div class="r-body green-block">
                          <div class="r-info">
                            <strong>Date of Test:</strong>
                            <span>{{ test.overAllInfo.testDate }}</span>
                          </div>
                          <div class="r-info">
                            <strong>Answered by:</strong>
                            <span
                              >{{ test.overAllInfo.answered }} out of
                              {{ test.overAllInfo.totalQuestions }}
                              students</span
                            >
                          </div>
                          <div class="r-info topperstrong-line">
                            <strong class="topperstrong">Topper:</strong>
                            <span
                              class="topper-name cursor_click eleipes-top-name"
                              :class="[
                                test.overAllInfo.toppersList.length > 1
                                  ? 'more'
                                  : '',
                              ]"
                              @click.stop="
                                gotoStudentResult(
                                  test.testId,
                                  test.testInstituteId,
                                  test.overAllInfo
                                )
                              "
                              >{{ test.overAllInfo.topper }}</span
                            >

                            <span
                              class="more-line"
                              @click="openTooltip(test, 'overall')"
                              v-if="test.overAllInfo.toppersList.length > 1"
                              >&nbsp;+{{
                                test.overAllInfo.toppersList.length - 1
                              }}
                              more</span
                            >
                            <span>
                              <v-tooltip
                                bottom
                                v-model="test.overAllInfo.showToppers"
                                content-class="student-names"
                              >
                                <template v-slot:activator="{ on }">
                                  <span v-on="on"></span>
                                </template>
                                <div
                                  class="student-name-block"
                                  @mouseleave="
                                    test.overAllInfo.showToppers = !test
                                      .overAllInfo.showToppers
                                  "
                                >
                                  <span
                                    v-for="(topperData, tidx) in test
                                      .overAllInfo.toppersList"
                                    :key="topperData.studentId + '-' + tidx"
                                  >
                                    <span
                                      class="studentName"
                                      @click="
                                        gotoStudentResult(
                                          test.testId,
                                          test.testInstituteId,
                                          topperData
                                        )
                                      "
                                      >{{ topperData.topper
                                      }}{{
                                        tidx !=
                                          test.overAllInfo.toppersList.length -
                                            1 &&
                                        test.overAllInfo.toppersList.length > 1
                                          ? ","
                                          : ""
                                      }}</span
                                    >
                                  </span>
                                </div>
                              </v-tooltip>
                            </span>
                          </div>
                          <div class="r-info">
                            <strong>Max Marks:</strong>
                            <span>{{ test.overAllInfo.maxMarks }}</span>
                          </div>
                          <div class="r-info">
                            <strong>Highest:</strong>
                            <span>{{ test.overAllInfo.highest }}</span>
                          </div>
                          <div class="r-info">
                            <strong>Average:</strong>
                            <span>{{ test.overAllInfo.average }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="r-footer">
                        <div
                          class="footer-col"
                          @click.stop="
                            gotoTest(test.testId, test.testInstituteId)
                          "
                        >
                          <v-btn text color="primary" class="r-btn">
                            <v-icon>mdi-eye</v-icon>View Test
                          </v-btn>
                        </div>
                        <div
                          class="footer-col"
                          @click.stop="
                            downloadResultAsExcel(test.scheduleId, test.testId)
                          "
                        >
                          <v-btn text color="primary" class="r-btn">
                            <v-icon>mdi-login mdi-rotate-90</v-icon>Result
                          </v-btn>
                        </div>
                      </div>
                    </v-touch>
                  </div>
                </div>
                <div class="date-box">
                  <div class="date">
                    <v-touch
                      class="result-box"
                      v-on:swipeleft="
                        flipReset(), (t2sActive = true), (currIndex = testIndex)
                      "
                      v-on:swiperight="
                        flipReset(), (t2fActive = true), (currIndex = testIndex)
                      "
                    >
                      <div class="left-move">
                        <svg
                          viewBox="-10 -10 70 95"
                          xml:space="preserve"
                          @click="
                            flipReset(),
                              (t2sActive = true),
                              (currIndex = testIndex)
                          "
                        >
                          <polyline
                            fill="none"
                            stroke="#666"
                            stroke-width="9"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            points="45.63,75.8 0.375,38.087 45.63,0.375 "
                          />
                        </svg>
                      </div>
                      <div class="right-move">
                        <svg
                          viewBox="-10 -10 70 95"
                          xml:space="preserve"
                          @click="
                            flipReset(),
                              (t2fActive = true),
                              (currIndex = testIndex)
                          "
                        >
                          <polyline
                            fill="none"
                            stroke="#666"
                            stroke-width="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            points="0.375,0.375 45.63,38.087 0.375,75.8 "
                          />
                        </svg>
                      </div>
                      <div class="res-body-1">
                        <div class="res-body">
                          <div class="subject-heading">
                            {{ test.overAllInfo.testName }}
                            <input
                              type="checkbox"
                              :value="test.scheduleId"
                              v-model="selectedScheduleIds"
                              class="select-checkbox"
                            />
                          </div>
                          <span v-if="instituteId == CONSTANTS_REF.AITS_INSTITUTE_ID[0]" 
                        >{{ `(${test.overAllInfo.instituteName})` }}</span>
                          
                          <h4 class="r-heading">
                            Batches
                          </h4>
                          <div class="r-body">
                            <!-- {{test}} -->
                            <span
                              v-for="(batch, idx) in test.batches"
                              :key="batch.id"
                              class="sub-box"
                            >
                              <span>{{ batch.name }}</span>
                              <span
                                v-if="
                                  test.batches.length > 1 &&
                                    idx < test.batches.length - 1
                                "
                                >,&nbsp;</span
                              >
                            </span>
                          </div>
                        </div>
                        <div class="r-footer bonus-footer" v-if="!test.isAitsTest">
                          <div
                            class="footer-col"
                            @click="openBonusModal(test)"
                            v-if="!isUserCoordinator"
                          >
                            <v-btn text class="r-btn" color="primary">
                              <v-icon>mdi-trophy-award</v-icon>
                              Award Bonus
                            </v-btn>
                          </div>
                          <div class="footer-col" v-if="user.role_id !== roleIds.TR" @click="evaluate(test)">
                            <v-btn text class="r-btn" color="primary">
                              <v-icon>mdi-file-check</v-icon> Re-Evaluate
                            </v-btn>
                          </div>
                        </div>
                      </div>
                    </v-touch>
                  </div>
                </div>
                <div class="date-box">
                  <div class="date">
                    <v-touch
                      class="result-box"
                      :class="!test.showOverAllInfo ? 'active' : ''"
                      v-on:swipeleft="
                        flipReset(), (s2fActive = true), (currIndex = testIndex)
                      "
                      v-on:swiperight="
                        flipReset(), (s2tActive = true), (currIndex = testIndex)
                      "
                    >
                      <div class="left-move">
                        <svg
                          viewBox="-10 -10 70 95"
                          xml:space="preserve"
                          @click="
                            flipReset(),
                              (s2fActive = true),
                              (currIndex = testIndex)
                          "
                        >
                          <polyline
                            fill="none"
                            stroke="#666"
                            stroke-width="9"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            points="45.63,75.8 0.375,38.087 45.63,0.375 "
                          />
                        </svg>
                      </div>
                      <div class="right-move">
                        <svg
                          viewBox="-10 -10 70 95"
                          xml:space="preserve"
                          @click="
                            flipReset(),
                              (s2tActive = true),
                              (currIndex = testIndex)
                          "
                        >
                          <polyline
                            fill="none"
                            stroke="#666"
                            stroke-width="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            points="0.375,0.375 45.63,38.087 0.375,75.8 "
                          />
                        </svg>
                      </div>
                      <div class="res-body">
                        <div class="subject-heading">
                          {{ test.overAllInfo.testName }}
                          <input
                            type="checkbox"
                            :value="test.scheduleId"
                            v-model="selectedScheduleIds"
                            class="select-checkbox"
                          />
                        </div>
                        <span v-if="instituteId == CONSTANTS_REF.AITS_INSTITUTE_ID[0]" 
                        >{{ `(${test.overAllInfo.instituteName})` }}</span>
                        <div
                          class="subject-result"
                          v-for="(sub, subIdx) in test.subjectWise"
                          :key="sub.subjectName + subIdx"
                        >
                          <div class="r-heading-subjects">
                            {{ sub.subjectName }}
                          </div>
                          <div class="r-body">
                            <div class="sub-box">
                              <div class="r-info-subjects">
                                <strong>Highest:</strong>
                                {{ sub.highest }}
                              </div>
                              <div class="r-info-subjects">
                                <strong>Avg:</strong>
                                {{ sub.average }}
                              </div>
                            </div>
                            <div
                              class="r-info-subjects cursor_click topperstrong-line1"
                            >
                              <strong class="topperstrong"
                                >Topper:&nbsp;</strong
                              >
                              <span
                                class="topper-name eleipes-top-name"
                                :class="[
                                  sub.toppersList.length > 1 ? 'more' : '',
                                ]"
                                @click.stop="
                                  gotoStudentResult(
                                    test.testId,
                                    test.testInstituteId,
                                    sub
                                  )
                                "
                                >{{ sub.topper }}</span
                              >

                              <span
                                class="more-line"
                                @click="openTooltip(test, 'subject', sub)"
                                v-if="sub.toppersList.length > 1"
                                >&nbsp;+{{
                                  sub.toppersList.length - 1
                                }}
                                more</span
                              >
                              <span>
                                <v-tooltip
                                  bottom
                                  v-model="sub.showToppers"
                                  content-class="student-names"
                                >
                                  <template v-slot:activator="{ on }">
                                    <span v-on="on"></span>
                                  </template>
                                  <div
                                    class="student-name-block"
                                    @mouseleave="
                                      sub.showToppers = !sub.showToppers
                                    "
                                  >
                                    <span
                                      v-for="(subTopper,
                                      subidx) in sub.toppersList"
                                      :key="subTopper.studentId + '-' + subidx"
                                    >
                                      <span
                                        class="studentName"
                                        @click="
                                          gotoStudentResult(
                                            test.testId,
                                            test.testInstituteId,
                                            subTopper
                                          )
                                        "
                                      >
                                        {{ subTopper.topper
                                        }}{{
                                          subidx !=
                                            sub.toppersList.length - 1 &&
                                          sub.toppersList.length > 1
                                            ? ", "
                                            : ""
                                        }}
                                        <!-- <span v-if="subidx != sub.toppersList.length-1 && sub.toppersList.length > 1">,&nbsp;</span> -->
                                      </span>
                                    </span>
                                  </div>
                                </v-tooltip>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="r-footer">
                        <div class="footer-col">
                          <v-btn
                            text
                            color="primary"
                            class="r-btn"
                            @click="gotoTest(test.testId, test.testInstituteId)"
                          >
                            <v-icon>mdi-eye</v-icon>View Test
                          </v-btn>
                        </div>
                        <div class="footer-col">
                          <v-btn
                            @click.stop="
                              downloadResultAsExcel(
                                test.scheduleId,
                                test.testId
                              )
                            "
                            text
                            color="primary"
                            class="r-btn"
                          >
                            <v-icon>mdi-login mdi-rotate-90</v-icon>Result
                          </v-btn>
                        </div>
                      </div>
                    </v-touch>
                  </div>
                </div>
              </div>
              <div class="card-actions" v-if="roleIds.ID === user.role_id && instituteId == CONSTANTS_REF.AITS_INSTITUTE_ID[0]">
                <span v-if="test.resultsPublishedAt" class="result-published-at">
                  <b>Published On:</b> {{ getFormatedDate(test.resultsPublishedAt) }}
                </span>
                <v-btn
                  v-else
                  @click.stop="openPublishConfirmation(test.testId)"
                  text
                  color="primary"
                  class="r-btn"
                >
                  Publish Results
                </v-btn>
              </div>
            </div>
          </div>
          <div v-intersect="infiniteScrolling"></div>
        </div>

      </div>
    </v-card>
    <AlertBox
      :width="modalwidth"
      :onClose="onClose"
      :component="cComponent"
      :status="status"
      :data="alertBoxData"
    />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import moment from "moment";
import constants from "@/utils/constants.js";

export default {
  name: "TestResults",
  computed: {
    ...mapState("userStore", ["token", "user"]),
  },
  data() {
    return {
      alertBoxData: null,
      status: false,
      cComponent: "",
      modalwidth: "50%",
      show: false,
      batches: [],
      isUserCoordinator: false,
      centers: [],
      selectedCenterId: [],
      selectedBatch: [],
      currentPage: 1,
      pageSize: 8,
      totalPages: 1,
      testResultList: [],
      gotAllTests: false,
      allowScroll: false,
      selectedTooltip: null,
      selectedTooltipSub: null,
      f2sActive: false,
      f2tActive: false,
      s2fActive: false,
      s2tActive: false,
      t2fActive: false,
      t2sActive: false,
      currIndex: 0,
      isLoadingFirstTime: true,
      instituteId:'',
      CONSTANTS_REF:constants,
      selectedScheduleIds: [],
    };
  },
  mounted() {
    this.getCurrentUser();
    this.setPageSize();
    // this.requestGetCenters();
    this.setIsPastTest(false);
    this.isUserCoordinator = this.isCoordinator();
    this.$forceUpdate();
    this.checkSessionData();
  },
  methods: {
    ...mapMutations("testStore", ["setIsPastTest"]),

    ...mapActions({
      getCenters: "centerAndBatchStore/getCenters",
      getCentersByUser: "centerAndBatchStore/getCentersByUser",
      getBatches: "centerAndBatchStore/getBatches",
      getTestResultsList: "resultStore/getTestResultsList",
      checkResultCalculated: "resultStore/checkResultCalculated",
      showLoader: "testStore/showLoader",
      publishResults: "resultStore/publishResults",
    }),
    ...mapMutations("app", ["addBreadCrumbChilde"]),

    updateRouteDetails(details) {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      switch (details.type) {
        case "centerIds":
          crd.tabDetails[crd.selectedTab].centerIds = details.data.centerIds;
          break;
        case "batchIds":
          crd.tabDetails[crd.selectedTab].batchIds = details.data.batchIds;
          break;
        default:
          break;
      }
      this.setRouteDetails(crd);
    },
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.selectedCenterId = crd.tabDetails[crd.selectedTab].centerIds; // load center ids from session
        this.selectedBatch = crd.tabDetails[crd.selectedTab].batchIds; // load batches in session
      }
      this.requestGetCenters();
      this.getTestList();
    },
    checkSessionData() {
      this.addBreadCrumbChilde([]);
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);

      if (rp.params.resetPage || !crd.routeName) {
        let tabDetail = {
          default: { page: 1, centerIds: [], batchIds: [] },
        };
        let routeDetails = {
          routeName: rp.name,
          selectedTab: "default",
          tabDetails: tabDetail,
        };
        this.setRouteDetails(routeDetails);
      }
      this.defaultData();
    },
    evaluate(test) {
      this.cComponent = "components/coordinator/ReEvaluateMarks";
      this.modalwidth = "500px";
      this.status = true;
      this.persistent = false;
      this.alertBoxData = test;
      this.$forceUpdate();
    },
    openBonusModal(test) {
      this.cComponent = "components/coordinator/BonusDetails";
      this.modalwidth = "1000px";
      this.status = true;
      this.persistent = false;
      this.alertBoxData = test;
      this.$forceUpdate();
    },
    openPublishConfirmation(testId) {
      this.cComponent = "components/coordinator/Tests/PublishConfirmationDialog";
      this.modalwidth = "500px";
      this.status = true;
      this.persistent = false;
      this.alertBoxData = { testId };
      this.$forceUpdate();
    },
    async onClose(data) {
      const { testId, confirmationType, action } = data;

      if (confirmationType === 'publish_result' && action === 'yes') {
        await this.publishTestResults(testId, data.rank_scale);
      }

      if (!data.status) this.alertBoxData = { testId: null };
      this.status = data.status;
    },
    openTooltip(test, type, sub) {
      if (type == "overall") {
        if (this.selectedTooltip == null) {
          test.overAllInfo.showToppers = true;
          this.selectedTooltip = test;
          if (
            this.selectedTooltipSub != null &&
            this.selectedTooltipSub.showToppers
          )
            this.selectedTooltipSub.showToppers = false;
          return;
        }
        if (this.selectedTooltip.testId == test.testId) {
          test.overAllInfo.showToppers = !test.overAllInfo.showToppers;
          if (
            this.selectedTooltipSub != null &&
            this.selectedTooltipSub.showToppers
          )
            this.selectedTooltipSub.showToppers = false;
        } else {
          this.selectedTooltip.overAllInfo.showToppers = false;
          this.selectedTooltip = test;
          test.overAllInfo.showToppers = true;
          if (
            this.selectedTooltipSub != null &&
            this.selectedTooltipSub.showToppers
          )
            this.selectedTooltipSub.showToppers = false;
        }
      } else if (type == "subject") {
        // subjectName
        if (this.selectedTooltipSub == null) {
          sub.showToppers = true;
          this.selectedTooltipSub = sub;
          if (
            this.selectedTooltip &&
            this.selectedTooltip.overAllInfo.showToppers
          )
            this.selectedTooltip.overAllInfo.showToppers = false;

          this.selectedTooltip = test;

          return;
        }
        if (this.selectedTooltipSub.subjectName == sub.subjectName) {
          // this.selectedTooltipSub.showToppers = false;
          if (this.selectedTooltip.testId == test.testId) {
            this.selectedTooltipSub = sub;
            sub.showToppers = !sub.showToppers;
            if (this.selectedTooltip.overAllInfo.showToppers)
              this.selectedTooltip.overAllInfo.showToppers = false;
          } else {
            this.selectedTooltipSub.showToppers = false;
            sub.showToppers = !sub.showToppers;
            this.selectedTooltipSub = sub;
            if (this.selectedTooltip.overAllInfo.showToppers)
              this.selectedTooltip.overAllInfo.showToppers = false;
            this.selectedTooltip = test;
          }
        } else {
          this.selectedTooltipSub.showToppers = false;
          this.selectedTooltipSub = sub;
          sub.showToppers = true;
          if (this.selectedTooltip.overAllInfo.showToppers)
            this.selectedTooltip.overAllInfo.showToppers = false;
        }
      }
      // this.openedTooltip = test;
      // return test.overAllInfo.showToppers = !test.overAllInfo.showToppers;
    },
    setPageSize() {
      let testCardBoxHeight = this.$refs.testCardBox.clientHeight;
      let pageSize = testCardBoxHeight / 280;
      pageSize = parseInt(pageSize);
      pageSize += 1;
      this.pageSize = pageSize * 6;
    },
    infiniteScrolling(entries, observer, isIntersecting) {
      // allowScroll after api gets data for 1st page
      if (isIntersecting && this.allowScroll) {
        this.currentPage++;
        this.getTestList();
      }
    },
    gotoTest(testId, testInstituteId) {
      this.$router.push({
        name: "result-anaylysis-preview-test",
        params: { test_id: testId, test_institute_id: testInstituteId },
      });
    },
    resetPage() {
      this.currentPage = 1;
      this.setPageSize();
      this.totalPages = 1;
      this.allowScroll = false;
      this.testResultList = [];
    },
    onPageChange(e) {
      this.currentPage = e;
    },
    gotoStudentResult(testId, testInstituteId, testDetails) {
      if (
        this.roleIds.CO === this.user.role_id ||
        this.roleIds.ID === this.user.role_id
      ) {
       // console.log("testDetails = ", testDetails);
        let studentName = testDetails.topper;
        sessionStorage.setItem("studentName", JSON.stringify({ studentName }));

        let studentDetail={
        active: 1,
        batch_id:Number(testDetails.batchId),
        id: testDetails.studentId,
        name: testDetails.topper,
        }
        sessionStorage.setItem("user-detail", JSON.stringify( studentDetail ));
      }
      let batch_id = testDetails.batchId;
      let student_test_id = testDetails.studentTestId;
      let student_id = parseInt(testDetails.studentId);
      let test_institute_id = testInstituteId;
      let test_name = testDetails.testName;
      let test_id = testId;
      this.$router.push({
        name: "response-analysis-coordinator",
        params: {
          test_name,
          student_test_id,
          test_institute_id,
          test_id,
          batch_id,
          student_id,
        },
      });
    },
    onBatchSelect(selectedBatch) {
      this.resetPage();
      this.selectedBatch = selectedBatch;
      this.updateRouteDetails({
        type: "batchIds",
        data: { batchIds: selectedBatch },
      });
    },
    onCenterSelect(centerIds) {
      this.resetPage();
      // this.selectedBatch = [];
      this.testResultList = [];
      if (centerIds && centerIds.length) {
        this.updateRouteDetails({ type: "centerIds", data: { centerIds } });
        this.$root.showLoader = true;

        this.getBatches({ center_id: centerIds })
          .then((response) => {
			  			if(!this.isLoadingFirstTime){

            this.$root.showLoader = false;
						  }
            if (response && response.list && response.list.length) {
              if (this.selectedBatch) {
                let arr = [];
                this.selectedBatch.map((xx, i) => {
                  let isExist = false;
                  response.list.map((x) => {
                    if (!isExist) {
                      isExist = xx === x.id;
                    }
                  });
                  if (!isExist) {
                    arr.push(xx);
                  }
                });
                if (arr && arr.length) {
                  arr.map((xx) => {
                    this.selectedBatch.splice(
                      this.selectedBatch.indexOf(xx),
                      1
                    );
                  });
                }
              }

              let batchIds = [];
              this.batches = response.list.map((x) => {
                batchIds.push(x.id);
                let c = {};
                c.text = x.name;
                c.value = x.id;
                c.checked =
                  this.selectedBatch && this.selectedBatch.indexOf(x.id) !== -1;
                return c;
              });
              // if (!this.gotAllTests) {
              //     this.gotAllTests = true;
              //     this.batches = this.batches.map((batch) => {
              //         batch.checked = true;
              //         return batch;
              //     });
              //     this.selectedBatch = batchIds;
              //     // this.getTestList(batchIds);
              // }
            } else {
              this.batches = [];
            }
          })
          .catch((err) => {
            this.$root.showLoader = false;

          });
      } else {
        this.batches = [];
      }
    },
    getCentersFunction() {
      if (this.isCoordinator()) {
        return "getCentersByUser";
      }
      return "getCenters";
    },
    isCoordinator() {
      const user = JSON.parse(sessionStorage.getItem("user"));

      if (user && user.role_id === constants.ROLES_ID.CO) {
        return true;
      }
	  if (user && user.role_id === constants.ROLES_ID.TR) {
        return true;
      }
      return false;
    },
    requestGetCenters() {
      this.$root.showLoader = true;

      this[this.getCentersFunction()]()
        .then((response) => {
			if(!this.isLoadingFirstTime){
          this.$root.showLoader = false;

			}
	//   console.log(this.$root.showLoader);

          let centerIds = [];
          this.centers = response.map((x) => {
            centerIds.push(x.id);
            let c = {};
            c.text = x.name;
            c.value = x.id;
            c.checked = this.selectedCenterId.includes(x.id);
            return c;
          });
          // this.onCenterSelect(centerIds);
        })
        .catch((err) => {
          this.$root.showLoader = false;
	//   console.log(this.$root.showLoader);

        });
    },
    getTestList() {
      // if (batchIds.length > 0) {
      let postData = {
        pagination: {
          page: this.testResultList.length,
          pageSize: this.pageSize,
        },
      };
      if (this.selectedCenterId && this.selectedCenterId.length)
        postData.center_ids = this.selectedCenterId;
      if (this.selectedBatch && this.selectedCenterId.length)
        postData.batch_ids = this.selectedBatch;
      this.$root.showLoader = true;
	  this.showLoader(true).then(res=>{
			this.$root.showLoader =true;
		}).catch(err=>{
			// this.$root.showLoader =true;

		})
	//   console.log(this.$root.showLoader);
      this.getTestResultsList(postData)
        .then((response) => {
          this.isLoadingFirstTime = false;
          // if(response.list.length == 0 && this.currentPage != 1 && !this.$route.query.resetPage) {
          //     this.onPageChange(1);
          //     return;
          // }
          this.allowScroll = true;
          this.totalPages = response.pagination.pageCount;
          if (response.list.length > 0) {
            this.processTestData(response.list);
          } else {
            this.$root.showLoader = false;
				//   console.log(this.$root.showLoader);
          }
        })
        .catch((err) => {
          this.$root.showLoader = false;
		  	//   console.log(this.$root.showLoader);

        });
      // }
    },
    processTestData(testResultList) {
      testResultList.map((test) => {
        let showOverAllInfo = true;
        let overAllInfo = {};
        let subjectWise = [];
        let testId = test.test_id;
        let scheduleId = test.schedule_id;
        let testInstituteId = test.test_institute_id;
        let topperDetails = test.topper.split(",");
        let fTopper = null;
        let resultsPublishedAt = test.results_published_at;

        if (!topperDetails) {
          this.$toasted.error("Error getting topper details.");
        } else {
          fTopper = topperDetails[0].split(":");
          if (fTopper) {
            let testBatches = test.batches.split(",");
            let batches = testBatches.map((batch) => {
              let batchDetails = batch.split(":");
              return {
                id: batchDetails[0],
                name: batchDetails[1],
              };
            });

            overAllInfo = {
              testName: test.test_name,
              testDate: this.getFormatedDate(test.started),
              answered: test.total_students_who_attempt_test,
              totalQuestions: test.total_student_count,
              topper: fTopper[0],
              maxMarks: test.max_marks,
              highest: test.high_marks,
              average: test.avg_marks,
              studentId: fTopper[1],
              batchId: fTopper[2],
              studentTestId: fTopper[3],
              showToppers: false,
              instituteName: test.institute_name,
            };
            overAllInfo.toppersList = topperDetails.map((t) => {
              let details = t.split(":");
              return {
                topper: details[0],
                studentId: details[1],
                batchId: details[2],
                studentTestId: details[3],
                testName: overAllInfo.testName,
                instituteName: test.institute_name,
              };
            });

            if (test.subjects) {
              subjectWise = test.subjects.map((subject) => {
                let subjectTopperDetails = subject.topper_details.split(",");
                let firstTopper = null;
                if (!subjectTopperDetails) {
                  this.$toasted.error("Error getting topper details.");
                } else {
                  firstTopper = subjectTopperDetails[0].split(":");
                  if (firstTopper) {
                    let subjectObj = {};
                    subjectObj.testName = test.test_name;
                    subjectObj.subjectName = subject.title;
                    subjectObj.highest = subject.highest_marks;
                    subjectObj.average = subject.avg_marks;
                    subjectObj.topper = firstTopper[0];
                    subjectObj.studentId = firstTopper[1];
                    subjectObj.batchId = firstTopper[2];
                    subjectObj.studentTestId = firstTopper[3];
                    subjectObj.showToppers = false;
                    subjectObj.toppersList = subjectTopperDetails.map((t) => {
                      let details = t.split(":");
                      return {
                        topper: details[0],
                        studentId: details[1],
                        batchId: details[2],
                        studentTestId: details[3],
                        testName: subjectObj.testName,
                      };
                    });
                    return subjectObj;
                  } else {
                    this.$toasted.error("Error getting topper details.");
                  }
                }
              });
            }
            let testObj = {
              showOverAllInfo,
              testId,
              scheduleId,
              overAllInfo,
              subjectWise,
              testInstituteId,
              batches,
              showTooltip: false,
              resultsPublishedAt,
              isAitsTest: test.is_aits_test,
            };
            this.testResultList.push(testObj);
          } else {
            this.$toasted.error("Error getting topper details.");
          }
        }
      });
      this.$root.showLoader = false;
	  	//   console.log(this.$root.showLoader);

    },
    getFormatedDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    onCenterchange(centerIds) {
      this.selectedCenterId = centerIds;
      // this.selectedBatch = null;
    },
    downloadResultAsExcel(scheduleId, testId) {
      let token = this.token;
      let domainUrl = process.env.VUE_APP_API_URL;
      let reqData ={
        test_schedule_id:scheduleId
      }
      this.checkResultCalculated(reqData)
      .then(response=>{

        let url =
          domainUrl +
          `/result-analysis/download-result?schedule_id=${scheduleId}&token=${token}&test_id=${testId}`;
        window.open(url, "_blank");
      }).catch(err=>{
        
      })
    },
    downloadResultAsExcelMulti() {
      let token = this.token;
      let domainUrl = process.env.VUE_APP_API_URL;
      let reqData = {
        test_schedule_id: this.selectedScheduleIds
      }
      this.checkResultCalculated(reqData)
        .then(response => {
          const query = this.selectedScheduleIds.map(id => `schedule_id=${id}`).join('&');
          let url = `${domainUrl}/result-analysis/download-result?${query}&token=${token}`;
          window.open(url, "_blank");
          this.selectedScheduleIds = [];
        }).catch(err => { });
    },
    flipReset() {
      this.f2sActive = false;
      this.f2tActive = false;
      this.s2fActive = false;
      this.s2tActive = false;
      this.t2fActive = false;
      this.t2sActive = false;
    },
     getCurrentUser(){
      let instituteData = JSON.parse(localStorage.getItem("myInstitute"));
      this.instituteId = instituteData?.id
      
    },
    async publishTestResults(testId, rankScale) {
      this.$root.showLoader = true;

      try {
        const resp = await this.publishResults({ test_id: testId, rank_scale: rankScale });
        if (resp.results_published_at) {
          this.testResultList = this.testResultList.map(test => {
            if (test.testId != testId) return test;

            return { ...test, resultsPublishedAt: resp.results_published_at };
          });
        }
      } catch (err) { 
        console.log(err); 
      }

      this.$root.showLoader = false;
    },
  },
  watch: {
    selectedCenterId(val) {
      if (val.length) {
        this.testResultList = [];
        this.onCenterSelect(val);
        if (!this.isLoadingFirstTime) this.getTestList();
      }
    },
    selectedBatch(val) {
      this.testResultList = [];
      if (!this.isLoadingFirstTime) this.getTestList();
    },
  },
};
</script>
